export default __webpack_public_path__ + "static/media/ufcpage.fd805afa.gif";